module.exports = __webpack_public_path__ + "img/setup-signature.5e1f1f4b.svg";